module.exports = __webpack_public_path__ + "static/ToolsResources2_Hero-811e5b1ead49cfb129cc651bb030f61f.jpg";